import React from "react";
import Iframe from "components/iframe";

const ContactForm = ({ data }) => (
	<div className="w-full flex justify-center max-w-[730px] mx-auto">
		<Iframe data={data} className="h-[1262px] md:h-[1149px]" />
	</div>
);

export default ContactForm;